export default "__VITE_ASSET__BTVcgepz__"